import React from "react";
import { useNav } from "../../contexts/NavContext";
import { apparel, equipment, footwear } from "../../data/secondNavContent";

export default function Nav3({ scrolled, category }) {
  // Contexts
  const { nav2Content } = useNav();

  return (
    <>
      {nav2Content && (
        <div
          className={`fixed left-0 top-[7rem] z-50 flex w-full gap-20 border-t bg-white px-4 py-12 transition-all duration-300 2xl:px-20 ${scrolled && "xl:top-[3.5rem]"}`}
        >
          {/* Equipment items */}
          {category === "equipment" &&
            Object.keys(equipment[0]).map((key) => (
              <div key={key}>
                <h1 className="mb-6 cursor-pointer font-bold hover:underline">
                  {key}
                </h1>
                <ul className="flex flex-col gap-2 text-sm">
                  {equipment[0][key].map((item, index) => (
                    <li key={index} className="cursor-pointer hover:underline">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          {category === "apparel" &&
            Object.keys(apparel[0]).map((key) => (
              <div key={key}>
                <h1 className="mb-6 cursor-pointer font-bold hover:underline">
                  {key}
                </h1>
                <ul className="flex flex-col gap-2 text-sm">
                  {apparel[0][key].map((item, index) => (
                    <li key={index} className="cursor-pointer hover:underline">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          {category === "footwear" &&
            Object.keys(footwear[0]).map((key) => (
              <div key={key}>
                <h1 className="mb-6 cursor-pointer font-bold hover:underline">
                  {key}
                </h1>
                <ul className="flex flex-col gap-2 text-sm">
                  {footwear[0][key].map((item, index) => (
                    <li key={index} className="cursor-pointer hover:underline">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </div>
      )}
    </>
  );
}
